import {SigninPageModel} from './model';
import {action, runInAction} from 'mobx';
import {EnvModel} from '../../env/model';
import {RouterModel} from '../../router/model';

export class SigninPageController {

  constructor(
    private model: SigninPageModel,
    private env: EnvModel,
    private router: RouterModel,
  ) {}

  @action
  onEnter = async () => {
    if (!this.env.isServer)
      return this.router.replace('/');

    return;
  };

  @action
  toggleLoading = () => {
    runInAction(() => {
        this.model.loading = !this.model.loading;
    });
  }

  @action
  setHasError = () => {
    runInAction(() => {
      this.model.hasError = true;
      this.model.hasError = true;
    });
  }
}